export const parseNumberInput = (value: string): number => {
  const trimmed = value.trim();
  if (!trimmed) return 0;

  let normalized = trimmed.replace(/[^\d,.-]/g, '');
  const hasComma = normalized.includes(',');
  const hasDot = normalized.includes('.');

  if (hasComma && hasDot) {
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (hasComma) {
    normalized = normalized.replace(',', '.');
  }

  normalized = normalized.replace(/(?!^)-/g, '');

  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const parsePercentInput = (value: string): number => {
  return parseNumberInput(value) / 100;
};
